import { __awaiter, __generator } from "tslib";
import { request } from '../lib/request';
var getDeveloperPayload = function (options) {
    var payload = {};
    if (options.mode !== 'default') {
        payload.binding_completion_action = options.mode;
        payload.payment_completion_action = options.mode;
    }
    if (options.theme) {
        payload['css-theme'] = options.theme;
    }
    if (options.modeSuccess !== 'default') {
        payload.payment_success_action = options.modeSuccess;
    }
    if (options.template) {
        payload.template = options.template;
    }
    if (options.remoteControl) {
        payload.remote_control = options.remoteControl;
    }
    if (options.diehardTemplateTag) {
        payload.diehard_template_tag = options.diehardTemplateTag;
    }
    return JSON.stringify(payload);
};
var createPayload = function (params) {
    var templateTag = params.isMobile ? 'mobile/form' : 'desktop/form';
    var developerPayload = getDeveloperPayload(params);
    var payload = {
        'template_tag': templateTag,
        'developer_payload': developerPayload
    };
    if (params.lang) {
        payload.lang = params.lang;
    }
    if (params.serviceToken) {
        payload.service_token = params.serviceToken;
    }
    if (params.currency) {
        payload.currency = params.currency;
    }
    return payload;
};
export var createBindingApi = function (apiHost, params) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, request({
                    method: 'POST',
                    url: "".concat(apiHost, "/web/create_binding"),
                    body: createPayload(params)
                })];
            case 1:
                data = _a.sent();
                return [2, data.binding_url];
        }
    });
}); };
